module.exports = __webpack_public_path__ + "static/media/6_MTA - New York City.0883bc7c.jpg";